import { useEffect } from 'react'
import { Col, TextField } from '@leroy-merlin-br/backyard-react'
import { InputLoading } from 'user/components'

import * as validator from 'utils/validators/validators'

import { useFormContext } from '../../../../../../contexts/FormContext'
import * as S from '../../../../styles/form-styled'

export default function General() {
  const {
    form: { register, watch, setValue },
    formState: { errors },
    legalEntity,
    loadingLegalEntity,
    getLegalEntity,
    companyFormIsDisabled,
    saveDraftWithDebounce
  } = useFormContext()

  const documentNumber = watch('companyDocumentNumber')

  useEffect(() => {
    const documentNumberOnlyNumbers = validator.stripCnpj(documentNumber)

    if (documentNumberOnlyNumbers?.length >= 14) {
      getLegalEntity()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentNumber])

  useEffect(() => {
    if (legalEntity) {
      setValue('companySocialName', legalEntity.company.socialName)
      setValue('companyFantasyName', legalEntity.company.fantasyName || '')

      setValue(
        'companyStateRegistration',
        legalEntity.stateRegistration?.number || ''
      )

      setValue('companyMainCnae', String(legalEntity.mainCNAE))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [legalEntity])

  const companyStateRegistrationIsDisabled =
    legalEntity?.stateRegistration?.exempt === true ||
    Boolean(legalEntity?.stateRegistration?.number?.length)

  const showForm = Boolean(legalEntity) || !companyFormIsDisabled

  return (
    <>
      <Col>
        <S.FieldWrapper>
          <InputLoading isLoading={loadingLegalEntity}>
            <TextField
              label="CNPJ"
              placeholder="xx.xxx.xxx/xxxx-xx"
              hint={errors.companyDocumentNumber?.message}
              disabled={loadingLegalEntity}
              value={documentNumber ? validator.formatCnpj(documentNumber) : ''}
              maxLength={18}
              {...register('companyDocumentNumber', {
                onChange: event => {
                  const fiscalId = validator.stripCnpj(event.target.value)
                  setValue('companyDocumentNumber', fiscalId)
                }
              })}
            />
          </InputLoading>
        </S.FieldWrapper>
      </Col>

      {showForm && (
        <>
          <Col size={{ giga: 6 }}>
            <S.FieldWrapper>
              <TextField
                label="Razão Social"
                disabled={companyFormIsDisabled}
                {...register('companySocialName')}
                hint={errors.companySocialName?.message}
                onBlur={saveDraftWithDebounce}
              />
            </S.FieldWrapper>
          </Col>

          <Col size={{ giga: 6 }}>
            <S.FieldWrapper>
              <TextField
                label="Nome Fantasia"
                disabled={companyFormIsDisabled}
                {...register('companyFantasyName')}
                hint={errors.companyFantasyName?.message}
                onBlur={saveDraftWithDebounce}
              />
            </S.FieldWrapper>
          </Col>

          <Col size={{ giga: 6 }}>
            <S.FieldWrapper>
              <TextField
                label="Inscrição Estadual"
                disabled={
                  companyFormIsDisabled || companyStateRegistrationIsDisabled
                }
                {...register('companyStateRegistration')}
                hint={errors.companyStateRegistration?.message}
                onBlur={saveDraftWithDebounce}
              />
            </S.FieldWrapper>
          </Col>

          <Col size={{ giga: 6 }}>
            <S.FieldWrapper>
              <TextField
                label="CNAE"
                disabled={companyFormIsDisabled}
                {...register('companyMainCnae')}
                hint={errors.companyMainCnae?.message}
                onBlur={saveDraftWithDebounce}
              />
            </S.FieldWrapper>
          </Col>

          <Col>
            <S.FieldWrapper>
              <TextField
                label="Inscrição Municipal"
                placeholder="xxxxxxxx-x"
                {...register('companyCityRegistration')}
                hint={errors.companyCityRegistration?.message}
                onBlur={saveDraftWithDebounce}
              />
            </S.FieldWrapper>
          </Col>
        </>
      )}
    </>
  )
}
